import { actionCreator } from '../../../../../../utils/reduxUtils';
import * as types from './types';

export const identification = (ref) => actionCreator(types.ID_REF, ref);
export const network = (ref) => actionCreator(types.NETWORK_REF, ref);
export const income = (ref) => actionCreator(types.INCOME_REF, ref);
export const socioEconomic = (ref) => actionCreator(types.SOCIOECONOMIC_REF, ref);
export const company = (ref) => actionCreator(types.COMPANY_REF, ref);
export const risk = (ref) => actionCreator(types.RISK_REF, ref);
export const restrictions = (ref) => actionCreator(types.RESTRICTIONS_REF, ref);